const mlFunction = {
    label: 'ML Function',
    key: 'ml_function',
    name: 'ml_function',
    required: false,
    type: 'select',
    options: [],
    labelField: 'label',
    valueField: 'value',
    helpText: 'ml_function'
};
const mlAlgorithm = {
    label: 'ML Algorithm',
    key: 'algorithm',
    name: 'algorithm',
    required: false,
    type: 'select',
    options: [],
    labelField: 'label',
    valueField: 'value',
    helpText: 'algorithm'
};
const mlVersion = {
    label: 'ML Version',
    key: 'ml_version',
    name: 'ml_version',
    required: false,
    type: 'select',
    options: [],
    labelField: 'label',
    valueField: 'value',
    helpText: 'ml_version'
};
const automationFields = [
    mlFunction,
    mlAlgorithm,
    mlVersion
];
export default automationFields;
